import { useState } from 'react';

import { IconPlus } from '@tabler/icons-react';
import { uploadConfig } from 'app-level/config/uploadConfig';
import DocumentDetails from 'features/pages/portfolio/DocumentLibrary/DocumentDetails';
import FileUpload from 'features/pages/portfolio/DocumentLibrary/FileUpload/FileUpload';
import { Modal } from 'ui-kit';
import { ButtonWithIcon } from 'ui-kit';

import { ApolloQueryResult, OperationVariables } from '@apollo/client';

import { FileType } from '__generated__/globalTypes';

import { GetDocumentLibrary } from 'query/__generated__/GetDocumentLibrary';
import { Document } from '../../../../ui-kit/hooks/__generated__/Document';

export interface DocumentCategoryProps {
  companyId: string;
  fileType: FileType;
  name: string;
  refetch: (
    variables?: Partial<OperationVariables> | undefined,
  ) => Promise<ApolloQueryResult<GetDocumentLibrary>>;
  docs: Document[];
}

const DocumentCategory = ({ companyId, fileType, name, docs }: DocumentCategoryProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <div className="mt-2">
      <div className="flex items-center justify-between bg-gray-900 p-1 px-2">
        <div className="text-md uppercase text-gray-300">{name}</div>
        <div className="document-category__upload">
          <ButtonWithIcon
            label="Document Upload"
            icon={<IconPlus size={16} color="#BDBDBD" />}
            type="tertiary"
            size="medium"
            iconPosition="right"
            onClick={() => setIsModalOpen(true)}
          />
        </div>
      </div>
      <div className="p-2 text-gray-600">
        Mark the checkbox next to a document to create a template
      </div>
      <DocumentDetails documents={docs} />
      {isModalOpen && (
        <Modal
          headerText="Add A Document"
          subText="New document will be added to following section"
          caption={`"${name}"`}
          setIsOpen={setIsModalOpen}
          type="document-library"
          width="100%"
          className="flex max-w-[785px] flex-col overflow-y-auto rounded-lg border border-pink-500 bg-background-canvas p-6 font-heebo text-white shadow-lg"
        >
          <FileUpload
            parentId={companyId}
            fileType={fileType}
            setIsOpen={setIsModalOpen}
            allowedFileTypes={uploadConfig.dealDocuments.allowedFileTypes || []}
          />
        </Modal>
      )}
    </div>
  );
};

export default DocumentCategory;
